module.exports = __webpack_public_path__ + "img/dummyprod8@2x.e30e2b24.png";